import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AppDispatch } from '../../data/storeConfig';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../data/reducers';
import * as assets from '../../assets/assets';
import { Product, ProductCategoryWithCount } from '../../data/models/product_list_response';
import { SearchProductCard } from '../../shared/components/product_components/search_product_card';
import { NavigationShell } from '../../shared/navigation_shell/navigation_shell';
import queryString from 'query-string';
import * as storeActions from '../../data/reducers/store.reducer';
import { useNavigate } from 'react-router-dom';
import { debounce } from 'ts-debounce';

export const SearchProductsPage = () => {
  const { storeSlug } = useParams<any>();
  const navigate = useNavigate();
  const { searchStoreProductsResult } = useSelector((rootState: RootState) => rootState.storeReducer);
  const dispatch = useDispatch<AppDispatch>();
  const [searchQuery, setSearchQuery] = useState('');

  const setQueryText = () => {
    const queryParameters: any = queryString.parse(location.search);
    setSearchQuery(queryParameters?.query);
  };

  const updateSearchQuery = (searchText: string) => {
    navigate(`/${storeSlug}/search?query=${searchText}`);
  };

  useEffect(() => {
    setQueryText();
    // dispatch search API call
    if (storeSlug && searchQuery) {
      dispatch(storeActions.fetchStoreProductsBySearch({ storeSlug: storeSlug, searchText: searchQuery }));
    }
  }, [location.search]);

  return (
    <NavigationShell title={'Results'}>
      <div>
        {/* Seach Button */}
        <div className="mx-6 mt-6 mb-4 md:mx-6 md:mt-6 md:mb-4">
          <div className="flex md:flex">
            <img className="px-2 md:px-2" src={assets.icons.SearchIcon} />
            <input
              className="w-full md:w-full form-control text-sm font-sans font-medium border-none focus:outline-none"
              type="text"
              name="Query"
              autoFocus={true}
              placeholder="Search..."
              value={searchQuery}
              // onChange={handleChangeQuery}
              onChange={(e: React.FormEvent<HTMLInputElement>) => {
                updateSearchQuery(e.currentTarget.value);
              }}
            />
            {searchQuery !== '' ? (
              <img
                className="px-2 md:px-2 cursor-pointer"
                src={assets.icons.CloseIcon}
                onClick={() => console.log('')}
              />
            ) : (
              <></>
            )}
          </div>
          <div className="mt-4 md:mt-4 border-t border-gray-300" />
        </div>

        {/* Search Result Product List Section - START */}
        {searchStoreProductsResult?.map((product: Product) => {
          return <SearchProductCard key={product.storeProductId} {...product} />;
        })}
      </div>
    </NavigationShell>
  );
};
